import React from "react";
import ReactDOM from "react-dom";

import Application from "./App";
import { Provider } from "react-redux";
import { configureStore } from "store/configureStore";

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <Application />
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js